module.exports = __webpack_public_path__ + "static/media/bubble-tail-right.e81d3177.svg";